import { orderXClient } from '@/service/client'
import { InstrumentList } from '@/types/generated/common/types'
import { InstrumentListRequest } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchInstrumentList(payload: InstrumentListRequest) {
  try {
    const { data } = await orderXClient.post<{ instrumentList?: InstrumentList }>('/api', {
      instrumentList: payload,
    })
    const instrumentListResponse = data.instrumentList
    if (!instrumentListResponse) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch instrument list',
      })
    }
    return instrumentListResponse as InstrumentList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
